module.exports = __webpack_public_path__ + "static/media/ChiliNoLogoSmall.712ea379.svg";